<template>
  <BaseCard class="relative py-3 pl-3 pr-1 flex flex-1 hover:opacity-80">
    <div
      class="flex flex-1 gap-x-4 cursor-pointer"
      @click="navigateToProgram"
    >
      <ProgramLogo
        :program="program"
        :size="75"
        :shadow="false"
      />
      <ProgramTeaser
        :program="program"
        class="text-sm w-40 pr-1"
      />
    </div>
    <div v-if="program.inclusions?.length" class="absolute top-1 right-1 flex justify-end bg-white rounded-full">
      <ConsumerProgramInclusionOptions
        :program="program"
        :consumer="consumer"
        @trash-program="$emit('trash-program', $event)"
      />
    </div>
    <div v-if="program.feedbacks?.length" class="absolute top-1 right-1 flex justify-end bg-white rounded-full">
      <ConsumerProgramFeedbackOptions
        :program="program"
        :consumer="consumer"
      />
    </div>
    <div class="flex flex-col justify-end">
      <ChevronRight class="w-6 text-gray-300 ml-4" />
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/core/components/base/BaseCard.vue';
import programHelper from '@/core/helpers/programHelper';
import ProgramTeaser from '@/program/components/program-teaser/ProgramTeaser.vue';
import ProgramLogo from '@/program/components/program-logo/ProgramLogo.vue';
import {PropType} from "vue";
import ConsumerProgramInclusionOptions from "@/consumer/components/consumer-programs/ConsumerProgramCardTrash.vue";
import Beneficiary from "@/customer/interfaces/Beneficiary";
import Customer from "@/customer/interfaces/Customer";
import {useRouter} from "vue-router";
import ConsumerProgramFeedbackOptions from "@/consumer/components/consumer-programs/ConsumerProgramCardFeedback.vue";
import {ProgramSnapshot} from "@/program/interfaces/Program";
import {ChevronRight} from "@lucide/vue";

const props = defineProps({
    program: {
        type: Object as PropType<ProgramSnapshot>,
        required: true
    },
    consumer: {
        type: Object as PropType<Customer | Beneficiary>,
        required: true
    },
    customer: {
        type: Object,
        required: true
    }
});

const router = useRouter();

defineEmits(['trash-program']);

const navigateToProgram = () => {
    const route = programHelper.generateRoute(props.program, props.consumer, props.customer);

    if (route) {
        router.push(route);
    }
};
</script>
